<template>
  <a class="company-info" :href="'/hh-wx/employerDetail/' + company.enterpriseId">
    <div class="img-wrap">
      <img :src="company.enterpriseLogo | avatar('company')" v-img-error-company alt="">
    </div>
    <div class="info-box">
      <div class="title-wrap">
        <h2 class="title van-ellipsis">{{company.shortName || company.enterpriseName}}</h2>
        <span class="time-tips" v-if="!hasArrow && sortType==2">{{position.publishTimeStr}}发布</span>
        <span class="time-tips" v-if="!hasArrow && sortType!=2">{{position.refreshTime}}</span>
      </div>
      <div class="separate-info-list">
        <span v-if="company.developStatusStr">{{company.developStatusStr}}</span>
        <span v-if="company.enterpriseIndustries">{{company.enterpriseIndustries}}</span>
        <span v-if="company.enterpriseScaleDesc">{{company.enterpriseScaleDesc}}</span>
      </div>
    </div>
    <van-icon name="arrow" class="info-arrow" v-if="hasArrow" />
  </a>
</template>

<script>
export default {
  props: {
    hasArrow:{
      type:Boolean,
      default:false
    },
    company: {
      default(){
        return {}
      }
    },
    position: {
      default(){
        return {}
      }
    }
  },
  data(){
    return {
      sortType: this.$route.query.sortType || ''
    }
  },
  watch: {
    '$route'(n,o){
      this.sortType = this.$route.query.sortType || '';
    },
    company(n,o){
    }
  },
  created(){
  }
};
</script>

<style scoped lang="scss">
.company-info{
  overflow: hidden;
  position: relative;
  padding: 15px 0;
  display: block;
  .img-wrap{
    float: left;
    width: 45px;
    height: 45px;
    line-height: 43px;
    border-radius: 4px;
  }
  .info-box{
    margin-left: 55px;
    margin-top: 3px;
    overflow: hidden;
    .title-wrap{
      display: flex;
      margin-bottom: 10px;
      line-height: 1;
      .title{
        margin-right: 10px;
        max-width: 80%;
        color: #333;
      }
      .time-tips{
        white-space: nowrap;
        margin-left: auto;
        font-size: 12px;
        color: #999;
      }
    }
  }
  .separate-info-list{
    font-size: 13px;
  }
  .info-arrow{
    position: absolute;
    right: 0;
    top: 50%;
    color: #999;
    font-size: 20px;
    margin-top: -10px;
  }
}
</style>
